import React__default, { useCallback } from 'react';
import { useFormContext, Controller } from 'react-hook-form';
import { FormControl } from '@sravni/react-design-system/lib/FormControl';
import { MaskInput } from '@sravni/react-design-system/lib/MaskInput';
import { Space } from '@sravni/react-design-system/lib/Space';
import { Edit } from '@sravni/react-icons';
import { useStyles, useIsMobile, mergeRefs } from '@sravni/react-utils';
import { TOO_MANY_REQUESTS_ERROR_TYPE, RUSSIA_PHONE_CODE } from '../../constansts/index.js';
import { handlePhoneBeforeMaskedStateChange, normalizePhone } from '../../helpers/phone.js';
import { convertMillisecondsToHumanString } from '../../helpers/time.js';
import { useClearErrorWithDelay } from '../../hooks/useClearErrorWithDelay.js';
import '../ContextProvider/components/IsLoadingProvider/provider.js';
import { useIsLoading } from '../ContextProvider/components/IsLoadingProvider/hook.js';
import '../ContextProvider/components/IsOTPSendedProvider/provider.js';
import { useIsOTPSended } from '../ContextProvider/components/IsOTPSendedProvider/hook.js';
import modules_13b53a7e from './styles.module.less.js';

const INPUT_NAME = "phone" /* FIELD_NAME.PHONE */;
const DEFAULT_LABEL = 'Телефон';
const DEFAULT_MASK = `${RUSSIA_PHONE_CODE} 999 999 99 99`;
const convertDisplayViewToValue = (displayView) => normalizePhone(displayView);
/** Компонент для ввода номера телефона */
const PhoneInput = React__default.forwardRef((props, ref) => {
    const { label = DEFAULT_LABEL, onBlur: onBlurOutside, onChange: onChangeOutside, onFocus: onFocusOutside, onIconClick, ...restProps } = props;
    const cx = useStyles(modules_13b53a7e);
    const { control, formState: { errors }, } = useFormContext();
    const isMobile = useIsMobile();
    const [isLoading] = useIsLoading();
    const [isOTPSended, setIsOTPSended] = useIsOTPSended();
    const [errorMessageShowTime] = useClearErrorWithDelay({ inputName: INPUT_NAME });
    const handlePhoneBeforeMaskedStateChangeCallback = useCallback(handlePhoneBeforeMaskedStateChange, []);
    const handleChangeCallback = useCallback((onPhoneChangeInner) => (value) => {
        onChangeOutside?.(value);
        onPhoneChangeInner(value ? convertDisplayViewToValue(value) : '');
    }, [onChangeOutside]);
    const handleInputCallback = useCallback((event) => {
        if (!isMobile)
            return;
        const { value } = event.currentTarget;
        // КОСТЫЛЬ изза бага в react-input-mask
        // При использовании autofill на мобильном устройстве значение инпута заменяется напрямую и у маски сносит башню и удаляются N последних символов
        // Удалить когда исправят в react-input-mask или перейти на другую либу
        const isDirectChangeValue = value === normalizePhone(value);
        if (isDirectChangeValue) {
            event.currentTarget.value = ' '.repeat(DEFAULT_MASK.length - value.length) + value;
        }
    }, [isMobile]);
    const handleIconClick = useCallback((event) => {
        setIsOTPSended(false);
        onIconClick?.(event);
    }, [setIsOTPSended, onIconClick]);
    const error = errors[INPUT_NAME];
    return (React__default.createElement(FormControl, { invalid: !!error },
        React__default.createElement(Space, { direction: "vertical" },
            React__default.createElement(Controller, { name: INPUT_NAME, control: control, render: ({ field: { onBlur, onChange, ...field } }) => (React__default.createElement(MaskInput, { ...field, ...restProps, onBlur: (e) => {
                        onBlur();
                        onBlurOutside?.(e);
                    }, onFocus: onFocusOutside, mask: DEFAULT_MASK, beforeMaskedStateChange: handlePhoneBeforeMaskedStateChangeCallback, readOnly: isLoading || isOTPSended, onInput: handleInputCallback, onChange: handleChangeCallback(onChange), label: label, 
                    // Для открытия цифровой клавиатуры на мобиле
                    inputMode: "decimal", icon: isOTPSended ? React__default.createElement(Edit, { onClick: handleIconClick, className: cx('icon') }) : null, ref: mergeRefs(field.ref, ref) })) }),
            React__default.createElement(FormControl.HelperText, null,
                error?.message,
                typeof error?.type === 'string' && error.type.includes(TOO_MANY_REQUESTS_ERROR_TYPE)
                    ? ` ${convertMillisecondsToHumanString(errorMessageShowTime)}`
                    : ''))));
});

export { PhoneInput };
//# sourceMappingURL=view.js.map
